<template>
  <div style="background:#FFFFFF">
    <v-container>
      <v-row justify="center" align="center">
        <!-- <v-col cols="12" md="6"> Lol </v-col> -->
        <v-col class="ps-0">
          <v-col class="page-heading"> {{ title }} </v-col>
          <v-col class="page-description">
            {{ description }}
          </v-col>
        </v-col>

        <v-img
          :src="image"
          class="ma-0"
          max-height="330"
          max-width="385"
          contain
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="#5c648b"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PublicPageHeader",
  props: ["title", "description", "image"],
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>

<style scoped></style>
